import { render, staticRenderFns } from "./RelatedNotes.vue?vue&type=template&id=ff4721e2"
import script from "./RelatedNotes.vue?vue&type=script&lang=js"
export * from "./RelatedNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports